import controller from 'controllers/Transactions';

const initialState = [];

export default (state = initialState, action) => {
  const fn = controller.actions[action.type];
  if(fn && typeof fn === 'function') return fn(action, state);
  return state;
}
